@import './nodeShared.scss';

$noSpaceDimensions: calc(var(--spacer) * 3);

@mixin nodeActionVisible {
  .node-action {
    visibility: visible;
  }
}

:host {
  height: auto;
  color: var(--main-titles-inputs-600);
}

:host([menu-open]) {
  .node--active {
    background-color: var(--background-transparent);
  }
  .node--dropdown-open {
    background-color: var(--chart-050-hover);
  }
}

.node-container--indented {
  padding-left: calc(var(--spacer) * 2.5);
}

.node--active, .node--dropdown-open {
  @include nodeActionVisible();
}

.node-wrapper:hover {
  background-color: var(--chart-051-hover);

  @include nodeActionVisible();
}

.node-icon {
  margin-right: var(--spacer);
  color: var(--chart-302-icon-buttons-titles);
}

.node-action {
  display: flex;

  margin-left: auto;

  visibility: hidden;
}

.node-details {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.drag {
  opacity: 0.4;
}

.drag-over {
  position: absolute;
  border-bottom: 2px solid var(--blue-layout-301-active);
  top: 30px;
  z-index: 100;
}

.drag-over:after {
  position: absolute;
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: var(--blue-layout-301-active);
  left: 16px;
  top: 1px;
  transform: translateY(-50%);
}

.node-name--trim {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: var(--node-name-font-size, var(--body-size));
}

.node-loader {
  width: auto;
  margin-right: var(--spacer);
  --loader-height: calc(var(--spacer) * 2);
}

.node--drag {
  border: 1px solid var(--blue-layout-301-active);
}

.collapse-btn-space {
  width: $noSpaceDimensions;
  min-width: $noSpaceDimensions;
  height: $noSpaceDimensions;
}

.name-prefix {
  margin-right: var(--spacer);
  display: flex;
}

gz-icon-button {
  display: flex;
}
